LabelsView = require 'app/scripts/views/label/labels-view'
View = require 'app/scripts/views/internal/view'

module.exports = class BoardLabelsView extends View
  viewTitleKey: 'labels'

  el: ->
    labelsView = @subview LabelsView, @model,
      board: @model
      popOverMethod: 'toggle'
      className: 'board-menu-content-frame'
      selectLabel: (idLabel) =>
        if @model.editable()
          labelsView.editLabel(idLabel)
    return labelsView.render().el
